module.exports = __webpack_public_path__ + "static/img/tenders_finalise.26da234e.png";